import React from 'react';
import api from 'api';
import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { Spinner, Modal } from 'hyperdb-utils';
import { AppLink } from '../../../routing/containers';
import DisplayMessage from '../components/DisplayMessage';
import { FILESTORE_URL } from '../../../../../config';
import { displayLocalDate } from '../../../../helpers/date';

class MessagesHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMessage: null,
    };
  }
  componentDidMount() {
    this.loadMessages(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.reload || this.props.reference !== nextProps.reference) {
      this.loadMessages(nextProps);
    }
  }
  componentWillUnmount() {
    this.props.api.message.setData({ relatedMessages: null });
  }
  render() {
    const messages = this.props.relatedMessages;
    return (
    <div>
      {
        !messages
          ? <div className="box box-primary"><Spinner show={ true } /></div>
          : <table className="table table-bordered table-striped">
              <thead>
                <tr><th>Message</th><th>read</th></tr>
              </thead>
              <tbody>
                {
                  messages.map((message, i) => {
                    const date = displayLocalDate(message.date, { timeFormat: 'HH:mm'});
                    return (
                      <tr key={ i }>
                        <td>
                          <div onClick={ this.toggleModalMessage.bind(this, message) } style={{cursor: 'pointer'}}>
                            { message.sender }<br/>{ message.subject }<br/>{ date }
                          </div>
                        </td>
                        <td>{ message.read ? <i className="fas fa-check text-success" /> : null }</td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
      }
      {
        !!this.state.selectedMessage
          ? <Modal onClose={ this.toggleModalMessage.bind(this, false) }>
              <Spinner show={ this.props.loading } />
              <DisplayMessage email={ this.state.selectedMessage } attachmentsBaseUrl={ this.attachmentsBaseUrl(this.state.selectedMessage) } showAttachments={ true } />
            </Modal>
          : null
      }
    </div>
    );
  }

  loadMessages({ reference, type }) {
    let url = `/get-history?reference=${reference}`;
    if (type) url += `&type=${type}`;
    this.props.api.message.getData({ url, propName: 'relatedMessages'});
  }
  toggleModalMessage(message) {
    this.setState({ selectedMessage: message });
    if (message) {
      this.props.api.message.getData({ url: `/${message.id}/content` })
        .then(content => {
          const { body, text, attachments } = content;
          const selectedMessage = { ...message, body, text, attachments };
          this.setState({ selectedMessage });
        });
    }
  }

  attachmentsBaseUrl(message) {
    const { currentUser } = this.props.api.getState('auth');
    const decoded = jwtDecode(currentUser.jwt);
    return `${FILESTORE_URL}/${decoded.client_id}/messages/${message.id}/attachments/`;
  }
}

export default api.connect(MessagesHistory, 'message');



// WEBPACK FOOTER //
// ./src/frontend/modules/email/message/containers/MessagesHistory.jsx